<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2023-06-01 13:44:18
 * @LastEditTime: 2025-10-17 17:13:37
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->

<template>
  <div
    v-if="sectionTitleStyle === 1"
    class="section-title"
    :class="checkTextAlign"
  >
    <h4 v-if="subtitle" class="subtitle">
      <span class="theme-gradient" v-html="subtitle" />
    </h4>
    <h2 class="title w-600" v-html="title" />
    <p v-if="description" class="description b1" v-html="description" />
  </div>

  <div
    v-else-if="sectionTitleStyle === 2"
    :class="`section-title-2 ${checkTextAlign}`"
  >
    <h2 class="title">{{ title }}</h2>
  </div>
  <div
    v-else-if="sectionTitleStyle === 3"
    :class="`section-title-3 ${checkTextAlign}`"
  >
    <h2 class="title">{{ title }}</h2>
    <p v-if="description" class="section-description" v-html="description" />
  </div>
</template>

<script>
export default {
  name: "SectionTitle",
  props: {
    subtitle: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    textAlign: {
      type: String,
      default: "left",
    },
    sectionTitleStyle: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    checkTextAlign() {
      if (this.textAlign === "left") return "text-start";
      else if (this.textAlign === "center") return "text-center";
      else if (this.textAlign === "end") return "text-end";
      else return "";
    },
  },
};
</script>

